import React, { useState } from 'react';
import { Plus, Users, Building2, DollarSign, CheckSquare, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickAddButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { icon: Users, label: 'Contact', path: '/contacts', color: 'bg-blue-500 hover:bg-blue-600' },
    { icon: Building2, label: 'Company', path: '/companies', color: 'bg-purple-500 hover:bg-purple-600' },
    { icon: DollarSign, label: 'Deal', path: '/deals', color: 'bg-green-500 hover:bg-green-600' },
    { icon: CheckSquare, label: 'Task', path: '/tasks', color: 'bg-orange-500 hover:bg-orange-600' },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Quick action menu */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-2 mb-2">
          {actions.map((action, index) => {
            const Icon = action.icon;
            return (
              <button
                key={index}
                onClick={() => {
                  navigate(action.path);
                  setIsOpen(false);
                }}
className={`${action.color} text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 min-w-[140px] transform transition-all hover:scale-105 animate-fade-in-up`}
style={{
                  animationDelay: `${index * 50}ms`,
                  animationFillMode: 'both'
                }}
              >
                <Icon className="w-5 h-5" />
                <span className="font-medium">{action.label}</span>
              </button>
            );
          })}
        </div>
      )}

      {/* Main FAB */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full bg-[#0176D3] hover:bg-[#0155A8] text-white shadow-lg flex items-center justify-center transition-all transform hover:scale-110 ${
          isOpen ? 'rotate-45' : ''
        }`}
      >
        {isOpen ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
      </button>

      {/* Animation styles handled via Tailwind and inline styles */}
    </div>
  );
};

export default QuickAddButton;
